<template lang="pug">
v-app-bar(
  :elevation="0"
  v-bind="{ ...$props, ...$attrs }"
)
  slot(name="navbar")

  v-toolbar-title.pl-1(v-if="!noTitle")
    v-card-title.pl-0.py-4 {{ caption }}
    v-card-subtitle.pl-0.pb-2(v-if="description") {{ description }} &nbsp;

  v-spacer

  slot(name="left")

  //- Ações agrupáveis
  v-menu(
    v-for="(category, index) in pins.categories"
    :key="`menu-${category}`"
    offset-y
  )
    template(#activator="{ on, attrs }")
      v-btn(
        v-bind="attrs"
        v-on="on"
        text
        rounded
      )
        v-icon mdi-menu-down
        | {{ category }}
    v-list
      action-bar-menu-item(
        v-for="(action,index) in pins.links.filter(x => x.category === category)"
        :key="`menu-${category}-${index}`"
        :action="action"
        @perform="opts => perform(opts)"
      )

  //- Ações não agrupáveis
  action-bar-pin(
    v-for="(action,index) in pins.links.filter(x => !x.category)"
    :key="`pin-${index}`"
    :action="action"
    @perform="opts => perform(opts)"
  )
    //- :color="getColor(action)"

  slot(name="right")

  //- MENU DE AÇÕES
  //-
  v-menu(
    v-if="actions.length"
    bottom left offset-y
  )
    template(#activator="{ on, attrs }")
      v-btn.ml-1(
        icon
        v-bind="attrs"
        v-on="on"
      )
        v-icon mdi-dots-vertical

    v-list(dense)
      //- Ações não agrupáveis
      action-bar-menu-item(
        v-for="(action,index) in acts.links.filter(x => !x.category)"
        :key="`menu-${index}`"
        :action="action"
        @perform="opts => perform(opts)"
      )

      //- Ações agrupáveis
      template(v-for="(category, index) in acts.categories")
        v-subheader {{ category }}

        action-bar-menu-item(
          v-for="(action,index) in acts.links.filter(x => x.category === category)"
          :key="`menu-${category}-${index}`"
          :action="action"
          @perform="opts => perform(opts)"
        )

  //- BOTÃO FECHAR
  v-tooltip(bottom v-if="closeable")
    template(#activator="{ on, attrs }")
      v-btn(
        icon
        v-bind="attrs"
        v-on="on"
        @click="$close(entity)"
      )
        v-icon mdi-close
    span
      span.text-md.font-weight-medium Fechar
      br
      span.font-weight-light Fecha esta página.
        br
        | Os dados não salvos são perdidos.

</template>

<style>
  .x-btn-navbar {
    border: 1px solid #9995;
  }
</style>

<script>
import { findRels } from '@/helpers/rels'
import ActionBarMenuItem from './ActionBarMenuItem'
import ActionBarPin from './ActionBarPin'
import { computeAll } from '@/helpers/conditions'
import { interpolate, isInterpolated } from '@/helpers/strings'

export default {
  components: {
    ActionBarMenuItem,
    ActionBarPin,
  },

  props: {
    entity: Object,
    color: String,
    title: String,
    noTitle: Boolean,
    nonCloseable: Boolean,
    context: Object,
  },

  computed: {
    eref: vm => vm.$route.params.eref,
    site: vm => vm.$route.params.site,

    caption: vm => vm.title || vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,

    closeable: vm => !vm.nonCloseable && !(vm.site === 'Home' && vm.eref === 'Index.Workspace'),

    links () {
      const items = this.entity?.links || []
      computeAll(items, this.context)
      return items.filter(item => !item.hidden)
    },

    actions: vm => findRels(vm.links, 'Action'),
    acts () {
      const links = [
        ...findRels(this.actions, 'Primary'),
        ...findRels(this.actions, 'Secondary'),
        ...findRels(this.actions, { excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },
    pins () {
      const links = [
        ...findRels(this.actions, { includes: [ 'Pinned', 'Primary']}),
        ...findRels(this.actions, { includes: [ 'Pinned', 'Secondary' ]}),
        ...findRels(this.actions, { includes: [ 'Pinned' ], excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },
  },

  methods: {
    perform(opts) {
      // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
      const { link } = opts
      if (link?.eref) {
        const eref = this.format(link.eref)
        opts.link = { ...link, eref }
      }
      this.$emit('perform', opts)
    },

    format(text) {
      return isInterpolated(text) ? interpolate(text, this.context) : text
    },
  },
}
</script>